$(document).ready(() => {
  $('#date_filter_from_year, #date_filter_to_year').on('change', function () {
    var $form = $(this).closest('form');
    $form.submit();
  });
});
